var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.currentSrc},on:{"load":_vm.onFullImageLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }